module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside-in",
    domProps: {
      "innerHTML": _vm._s(_vm.page)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab6d828"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inside.vue
// module id = 596
// module chunks = 2